module.exports = __webpack_public_path__ + "img/manage-img3.241aefed.png";